/**
 * @flow
 * @relayHash c13e271ceda891ebcc3e3e44aaf92eca
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateCannedSecurityQuestionMutationVariables = {|
  cannedSecurityQuestionId: string,
  enabled: boolean,
|};
export type UpdateCannedSecurityQuestionMutationResponse = {|
  +updateCannedSecurityQuestion: ?{|
    +cannedSecurityQuestion: ?{|
      +id: string,
      +question: string,
      +enabled: boolean,
    |}
  |}
|};
export type UpdateCannedSecurityQuestionMutation = {|
  variables: UpdateCannedSecurityQuestionMutationVariables,
  response: UpdateCannedSecurityQuestionMutationResponse,
|};
*/


/*
mutation UpdateCannedSecurityQuestionMutation(
  $cannedSecurityQuestionId: ID!
  $enabled: Boolean!
) {
  updateCannedSecurityQuestion(cannedSecurityQuestionId: $cannedSecurityQuestionId, enabled: $enabled) {
    cannedSecurityQuestion {
      id
      question
      enabled
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "cannedSecurityQuestionId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "enabled",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateCannedSecurityQuestion",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "cannedSecurityQuestionId",
        "variableName": "cannedSecurityQuestionId"
      },
      {
        "kind": "Variable",
        "name": "enabled",
        "variableName": "enabled"
      }
    ],
    "concreteType": "UpdateCannedSecurityQuestion",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "cannedSecurityQuestion",
        "storageKey": null,
        "args": null,
        "concreteType": "CannedSecurityQuestionNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "question",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "enabled",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateCannedSecurityQuestionMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateCannedSecurityQuestionMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateCannedSecurityQuestionMutation",
    "id": null,
    "text": "mutation UpdateCannedSecurityQuestionMutation(\n  $cannedSecurityQuestionId: ID!\n  $enabled: Boolean!\n) {\n  updateCannedSecurityQuestion(cannedSecurityQuestionId: $cannedSecurityQuestionId, enabled: $enabled) {\n    cannedSecurityQuestion {\n      id\n      question\n      enabled\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6e1d071ac55fbe7c3f25587ccb6f693e';
module.exports = node;
